module.exports = __webpack_public_path__ + "static/media/Confirm.27867ff9.svg";